import Component from './Component';


export default class PreferenceMenu extends Component {
  load() {
    this.initPreferenceMenu();
    super.load();
  }


  // Simple slider idea - https://codepen.io/doodlemarks/pen/DvgXvy


  initPreferenceMenu() {
    const thisCont = this;
    // create a menu for the preference menu

    this.refreshSlider();

    $(window).on('resize', () => {
      thisCont.refreshSlider();
    });

  }

  refreshSlider() {
    const menuItems = document.querySelectorAll('.pref-centre-menu__link');
    const panels = $('.pref-centre__panel');
    const slideCount = panels.length;
    let slideWidth = panels.width();
    let sliderUlWidth = slideCount * slideWidth;

    let props = {
      panels : panels,
      slideCount : slideCount,
      slideWidth : slideWidth,
      sliderUlWidth : sliderUlWidth,
    };

    // panelProps can be later called from PreferenceUser.js depending on login status.
    window.panelProps = {...window.panelProps, ...props}; // add props to existing panelProps object.

    // the order in menuItems array is Favourites, Profile, Settings.
    menuItems.forEach((menuItem) => {
      // console.log('menuItem:', menuItem);
      menuItem.addEventListener('click', (e) => {
        e.preventDefault();
        changePanel(menuItem, props.sliderUlWidth, props.slideWidth);
      });
    });


    // append inline stylesheet
    let styles = ` root: { --var-slidewidth: ${props.slideWidth} } `;
    let styleHtml = $.parseHTML(styles);
    const target = $('.js-pref-centre');
    target.html(styleHtml);  //append HTML to element TODO: <style> in html, and replace contents

    $('.pref-centre__group-of-panels').css({ width: props.sliderUlWidth }); // , marginLeft: 0
    // $('.pref-centre__panel').css({ width: slideWidth });  // replaced with css. TODO: test working?

    // TODO: replace more JS with CSS? .pref-centre__group-of-panels margin-left
  }
}

const changePanel = (menuItem, sliderUlWidth, slideWidth) => {
  // console.log('changePanel to: ', menuItem);
  // console.log('disabled??: ', menuItem.getAttribute('disabled')); // has attribute??

  // can only changePanel on the preference center page
  if (!document.querySelector('.pref-centre')) {
    return;
  }

  console.log('menuItem n?: ', menuItem);
  if (menuItem.getAttribute('disabled') !== null) { // will be null if no disabled attribute.
    // display login modal.
    $('#login-choice-modal').modal('show');
    return;  // early return.
  }
  // change panel to the newly chosen menu item.
  const panelNo = menuItem.getAttribute('data-menu-item');
  const menuTextItems = document.querySelectorAll('.pref-centre-menu__link span');

  // add menu selected styling
  menuTextItems.forEach((menuLoopItem) => {
    menuLoopItem.classList.remove('pref-centre-menu__link-text--selected'); // remove from all.
  });
  menuItem.children[0].classList.add('pref-centre-menu__link-text--selected'); // add to provided menuItem.

  $('.pref-centre__group-of-panels').css({ width: sliderUlWidth, marginLeft: -slideWidth * panelNo });
}

window.panelProps = {};
window.panelProps.changePanel = changePanel; // add function to global panelProps object.


